export default "__VITE_ASSET__CADAEtDG__"